import { StyleProps } from '@chakra-ui/react';
import { ArrowLeftIcon, ArrowRightIcon } from '@udacity/chakra-uds-icons';

import { ButtonLink } from '~/components/button-link';
import { useI18n } from '~/hooks/use-i18n';

export type PrimaryButtonLinkProps = {
  href: string;
  label: string;
  onClick?: () => void;
  width?: StyleProps['width'];
  isDisabled?: boolean;
  withArrow?: boolean;
};

export function PrimaryButtonLink({
  href,
  isDisabled,
  label,
  onClick,
  width,
  withArrow = true,
}: PrimaryButtonLinkProps) {
  const { isRtl } = useI18n();

  function getIconProps() {
    if (withArrow) {
      return isRtl
        ? {
            leftIcon: <ArrowLeftIcon height='20px' width='20px' />,
            size: 'icon-left',
          }
        : {
            rightIcon: <ArrowRightIcon height='20px' width='20px' />,
            size: 'icon-right',
          };
    }
  }

  return (
    <ButtonLink
      linkProps={{ href }}
      buttonProps={{
        backgroundColor: 'accent.lime',
        colorScheme: 'sea-foam',
        isDisabled,
        variant: 'solid',
        _hover: {
          backgroundColor: '#ddff56',
        },
        ...getIconProps(),
        onClick,
        width,
      }}
    >
      {label}
    </ButtonLink>
  );
}
